import { ChatListItemProps } from "../types"
import React from "react"
import { observer } from "mobx-react-lite"
import { CheckBox } from "~widgets/check-box"
import styled from '~/ui/styled'
import ChatListItemCore from "./chat-list-item-core"

const ItemRow = styled.button`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  align-items: center;
`

const CheckWrap = styled.div`
  padding-left: ${({ theme }) => theme.space.md};
`

const ChatListItem: React.FC<ChatListItemProps> = ({ item, onItemClick, selecteds }) => {
  return (
    <ItemRow type="button" onClick={() => onItemClick?.(item)}>
      {selecteds && (
        <CheckWrap>
          <CheckBox curValue={selecteds} value={item.chat_id} />
        </CheckWrap>
      )}
      <ChatListItemCore item={item} />
    </ItemRow>
  )
}
export default observer(ChatListItem)
